import { HasIdName } from "~/@shared/api-types/id-name-display"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"
import { MajorOccupation, MinorOccupation } from "~/api/_common/types-for-occupations"

const PATH = "/new-grad-jobs/master-data"

type GetNewGradJobsMasterData = {
  data: MasterDataForNewGradJobs
}

export const fetchGetNewGradJobsMasterData = defineFetcher((): Promise<GetNewGradJobsMasterData> => {
  return GET(PATH)
})

export interface MasterDataForNewGradJobs {
  major_occupations: Array<MajorOccupation>
  minor_occupations: Array<MinorOccupation>
  regions: Array<HasIdName>
  grad_years: Array<string>
}
